import React from 'react';
import PropTypes from 'prop-types';
import './EtchRichText.scss';
import CTARenderer from '../CTARenderer/CTARenderer.component';
import PopularCategories from '../PopularCategories';
import * as analytics from '../../analytics';

const EtchRichText = (props) => {

  const { opts = {} } = props;
  const {
    alignment,
    html,
    id = 'richtext'
  } = opts;

  const sanitizedHtml = `${html}`.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,'');

  if(props.opts?.html.includes('cm_sp=popcats')){
    return (
        <PopularCategories opts={opts} channel={props.channel}>
          {analytics.track('load', {
            eventType: 'load',
            widgetId: props.opts.id
          })}
        </PopularCategories>
    );
  }

  else if (sanitizedHtml?.indexOf('playVideo') != -1) {
    const newHTML = sanitizedHtml?.replace(/javascript:playVideo\(([^)]+)\)/,'#');
    const matchesVideo = sanitizedHtml?.match(/javascript:playVideo\(([^)]+)\)/);
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <CTARenderer ctaLink={matchesVideo?.[0]}>
        <div id={id} className={`etchRichText etchRichText--${alignment}`} dangerouslySetInnerHTML={{ __html: newHTML }} />
      </CTARenderer>
    );  
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div id={id} className={`etchRichText etchRichText--${alignment}`} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
  );
};

EtchRichText.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    ctaLink: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    heroMedia: PropTypes.object,
    heroMediaMobile: PropTypes.object,
    eventLogo: PropTypes.object,
    eventLogoMobile: PropTypes.object,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    cta: PropTypes.string,
    collectionLink: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    cornerCaption: PropTypes.string,
    type: PropTypes.string
  }).isRequired,
  html: PropTypes.string
};
EtchRichText.defaultProps = {
  html: null
};

export default EtchRichText;
